import { computed, ref } from "@vue/composition-api";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import usePaymentPackage from "@/hooks/usePaymentPackage";
import { PaymentPackageMap } from "@/views/PageScheduledMassMessage/type";

export default function usePrice() {
  const { findAll } = usePaymentPackage();
  const priceList = ref<PaymentPackage[]>([]);
  findAll([PaymentPackageEnum.MESSAGE_ATTACHMENT]).then(r => (priceList.value = r));

  const paymentPackageMap = computed<PaymentPackageMap>(() =>
    priceList.value.reduce<PaymentPackageMap>((acc, price) => {
      acc[price.id] = price.amount;
      return acc;
    }, {})
  );

  return {
    paymentPackageMap,
  };
}
